import AppProvidersWrapper from "./components/wrappers/AppProvidersWrapper"
import AppRouter from "./routes/AppRouter"
//import AppRouter from "./routes/router"
import { createContext } from 'react';
import { RootStore } from '@/stores';
import '@/assets/scss/style.scss'
import './App.css'
import './index.css';
import { AuthProvider } from "./context/AuthContext"
import { LanguageProvider } from "./context/LanguageContext";

// Subscribe to language changes for store updates
// import { reaction } from 'mobx';
// import i18n from './i18n';

// // React to language changes
// i18n.on('languageChanged', (lng) => {
//   // Update store translations when language changes
//   rootStore.educationStore.onLanguageChange();
// });

//configureFakeBackend()
console.log("App start");
const rootStore = new RootStore();
export const StoreContext = createContext<RootStore | null>(null);

function App() {
  const el = document.querySelector<HTMLMetaElement>('meta[name="app-version"]');
  if(el) {
    el.setAttribute("content", import.meta.env.VITE_APP_VERSION || '1.0.1')
  }
  

  return (
    <AppProvidersWrapper>
      <StoreContext.Provider value={rootStore}>
        <LanguageProvider>

          <AuthProvider> {/* TODO review this */}
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>

      </StoreContext.Provider>
    </AppProvidersWrapper>
  )
}

export default App
